import { effectScope, toValue, watchEffect } from "vue";
import { useVueApp } from "./use-vue-app";

type Listener<T extends [...unknown[]]> = (...args: T) => unknown;

type Watcher<
  ListenerArguments extends unknown[],
  FactoryArguments extends unknown[],
> = (listener: Listener<ListenerArguments>, ...args: FactoryArguments) => void;

export function useMaybeWatcher<
  ListenerArguments extends unknown[],
  FactoryArguments extends unknown[],
>(
  composable: () =>
    | Watcher<ListenerArguments, FactoryArguments>
    | null
    | undefined,
  listener: Listener<ListenerArguments>,
  ...args: FactoryArguments
) {
  const app = useVueApp();
  watchEffect((onCleanup) => {
    const fn = toValue(composable);
    if (!fn) return;

    const scope = effectScope();
    scope.run(() => {
      app.runWithContext(async () => {
        // Use spread only if args is provided
        fn(listener, ...args);
      });
    });

    onCleanup(() => {
      scope.stop();
    });
  });
}
